class LoansDetailPrepaymentsController {
  constructor() {
  }
}

export default LoansDetailPrepaymentsController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailPrepayments/loansDetailPrepayments.controller.js